<template>
  <div class="wrapper">
    <Header class="header" data-title="상품추천"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section class="hr full mb0">
          <div class="titArea mb5">
            <h2 class="titH3 normal">
              고객님을 위한
              <br />
              맞춤 추천 상품이에요!
            </h2>
          </div>

          <!--
            slide
            TODO css 파일 확인 필요
            * 퍼블리싱 파일과 실제 적용 화면 다름
           -->
          <div class="slide goodsList large recomm prdViewRecomm" id="slide1">
            <ul class="slideList">
              <li v-for="(value, key) in prdList" :key="key" :idx="value.productIndex">
                <div class="rcdBox" @click="goDetail(value.productIndex, value.discntFlag)">
                  <div class="block">
                    <span class="rank" v-if="key == 0">
                      <img src="@/../static/img/mw/content/img_badge_best1.png" alt="BEST 인기상품 1st" />
                    </span>
                    <span class="rank" v-if="key == 1">
                      <img src="@/../static/img/mw/content/img_badge_best2.png" alt="BEST 인기상품 2st" />
                    </span>
                    <span class="rank" v-if="key == 2">
                      <img src="@/../static/img/mw/content/img_badge_best3.png" alt="BEST 인기상품 3st" />
                    </span>
                    <div class="img">
                      <div class="badgeArea">
                        <span class="badge" v-for="(tag, key) in value.tagInfos.topTags" :key="key"><img :src="tag.imgPath" /></span>
                      </div>
                      <img :src="value.thumbnail" :alt="value.displayName" />
                    </div>
                    <p class="tit row2">
                      {{ value.displayName }}
                    </p>
                    <p class="desc">{{ value.model }}</p>
                    <div class="hashtag" v-if="value.tagInfos.bottomTags.length > 0">
                      <span v-for="(tag, key) in value.tagInfos.bottomTags" :key="key">{{ tag.tagName }}</span>
                    </div>
                  </div>

                  <div class="prdPrice line">
                    <div class="row">
                      <span class="info">렌탈료</span>
                      <div class="val">
                        <span class="price">
                          월
                          <em class="money bold">{{ value.rentalAmount | currency }}</em>
                          원
                        </span>
                      </div>
                    </div>
                    <div class="row">
                      <span class="info">예상 혜택가</span>
                      <div class="val">
                        <span class="price pointC1">
                          월
                          <em class="money bold">{{ value.cardDCrentalAmount | currency }}</em>
                          원
                        </span>
                      </div>
                    </div>
                  </div>
                  <p class="txtXS pointC1 mt5 ar">
                    제휴카드 청구할인 혜택가 (
                    <i>{{ value.rentalPeriod }}</i>
                    개월 총
                    <i>{{ ((value.rentalAmount - value.cardDCrentalAmount) * value.rentalPeriod) | currency }}</i>
                    원 할인)
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </section>

        <CommonBanner></CommonBanner>

        <MessagePop v-if="messagePop" @close="messagePop = false">
          <p v-html="msg"></p>
        </MessagePop>

        <div class="btnArea sticky">
          <button type="button" class="btn_p" @click="nextPage" :disabled="disableFlag">확인</button>
        </div>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import * as customjs from '@/../static/js/m.front.js';
import $ from 'jquery';
import CommonBanner from '@/components/banner/CommonBanner';
import MessagePop from '@/components/popup/MessagePop';

export default {
  name: 'productRecommendStep2',
  components: { CommonBanner, MessagePop },
  mounted() {
    this.pickMenuIndex = this.$route.params.pickMenuIndex;
    this.age = this.$route.params.age;
    this.family = this.$route.params.family;
    this.recomListInit();
  },
  data: function() {
    return {
      pickMenuIndex: '',
      family: null,
      age: null,
      messagePop: false,
      msg: null,
      prdList: [],
      bannerList: [],
      currentProductIdx: 0,
      disableFlag: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    recomListInit: function() {
      ApiService.service('GET', '/product/recommend/category/' + this.pickMenuIndex + '/age/' + this.age + '/familytype/' + this.family)
        .then(({ data }) => {
          this.prdList = data.result;
          if (!this.prdList || this.prdList.length == 0) {
            this.disableFlag = true;
          } else {
            this.currentProductIdx = this.prdList[0].productIndex;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        })
        .finally(() => {
          customjs.slideInit('#slide1', 0, false, 300, false, 'auto', 8, null, null, this.slideChanged);
        });
    },
    goDetail: function(idx, discntFlag) {
      if (idx != '0' && discntFlag != 'Y') {
        this.$router.push('/product/category/detail/' + idx);
      } else {
        this.msg = '단종된 상품입니다.';
        this.messagePop = true;
      }
    },
    nextPage: function() {
      this.$router.push('/product/category/detail/' + this.currentProductIdx);
    },
    slideChanged(index) {
      this.currentProductIdx = this.prdList[index].productIndex;
    },
  },
  destroyed() {},
};
</script>
